module.exports = __webpack_public_path__ + "static/media/tier2.5739b376.svg";